/** Textos de ayuda y etiquetas de indicadores compartidos por las pantallas y el PDF de reportes. */
export const REPORT_HELP = {
  user: 'Nombre y código del usuario App. Toca el nombre para abrir su reporte con el mismo periodo.',
  first:
    'Hora de la primera visita a un cliente en el periodo. Si el periodo tiene más de un día, se muestra también la fecha.',
  last: 'Hora de la última visita a un cliente en el periodo. No incluye liquidaciones. Si el periodo tiene más de un día, se muestra también la fecha.',
  effectiveness:
    'Clientes visitados en ruta / Clientes en ruta (Meta). Es la misma Efectividad de visita del reporte del usuario.',
  visitEffectiveness:
    'Porcentaje de clientes de la ruta que tus usuarios visitaron físicamente en el periodo. Clientes visitados en ruta / Clientes en ruta (Meta).',
  planned:
    'Visitas planificadas en las rutas de tus usuarios para el periodo. Si un cliente está planificado más de una vez, cuenta cada visita.',
  visited:
    'Clientes de la ruta que tus usuarios visitaron físicamente, con check-in dentro de la geocerca.',
  unvisited: 'Clientes en ruta (Meta) que no recibieron visita en el periodo.',
  outside: 'Clientes visitados que no estaban en la ruta del periodo. No suman a la efectividad.',
  outsideColumn: 'Clientes visitados que no estaban en la ruta del periodo.',
  geofence:
    'Actividades registradas dentro de geocerca / Total de actividades en el periodo. No varía por tipo de actividad en la tabla.',
  geofenceKpi:
    'Actividades registradas dentro de geocerca / Total de actividades en el periodo. Mismo indicador que el detalle de actividades del usuario.',
  tasks: 'Tareas en punto de venta ejecutadas / Tareas asignadas en el periodo.',
  tasksColumn: 'Tareas en punto de venta ejecutadas / Tareas asignadas.',
  active: 'Usuarios App con al menos una actividad registrada en el periodo.'
}
export const TRANSACTION_COPY = {
  summary: [
    'Efectividad de venta/entrega/cobro',
    'Clientes en ruta con al menos un pedido, entrega o cobro / Clientes en ruta (Meta).'
  ],
  orders: [
    'Efectividad de venta',
    'Clientes únicos en ruta con pedido registrado / Meta de clientes del periodo. Mismo indicador que el detalle de actividades en Pedido.'
  ],
  charges: [
    'Efectividad de cobro',
    'Clientes únicos en ruta con cobro registrado / Meta de clientes del periodo. Mismo indicador que el detalle de actividades en Cobro.'
  ],
  deliveries: [
    'Efectividad de entrega',
    'Clientes únicos en ruta con entrega registrada / Meta de clientes del periodo. Mismo indicador que el detalle de actividades en Entrega.'
  ],
  pos: [
    'Clientes con ejecución en punto de venta',
    'Clientes en ruta con tareas registradas / Clientes en ruta (Meta).'
  ]
}
